import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';

const STATUS_OPTIONS = ['all', 'active', 'inactive'];
const STATUS_LABEL_KEYS = { all: 'screens.brokers.statusAll', active: 'screens.brokers.statusActive', inactive: 'screens.brokers.statusInactive' };

const Filter = ({ search, setSearch, setPage, statusFilter, setStatusFilter, filtered }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '14px 32px',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.6)',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ position: 'relative', flex: 1, minWidth: 240, maxWidth: 380 }}>
        <div style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
          <Icon name='search' color='#94a3b8' size={15} />
        </div>
        <input
          value={search}
          onChange={e => {
            setSearch(e.target.value);
            setPage(1);
          }}
          placeholder={t('screens.brokers.searchPlaceholder')}
          style={{
            width: '100%',
            padding: '9px 12px 9px 36px',
            background: '#fff',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 13,
            color: S.textPrimary,
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      </div>
      <select
        value={statusFilter}
        onChange={e => {
          setStatusFilter(e.target.value);
          setPage(1);
        }}
        style={{
          padding: '8px 12px',
          background: '#fff',
          border: `1px solid ${S.borderLight}`,
          borderRadius: 8,
          fontSize: 13,
          color: S.textSecondary,
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        {STATUS_OPTIONS.map(o => (
          <option key={o} value={o}>
            {t(STATUS_LABEL_KEYS[o])}
          </option>
        ))}
      </select>
      <span style={{ marginLeft: 'auto', fontSize: 12, color: S.textMuted }}>{t('screens.brokers.resultsCount', { count: filtered.length })}</span>
    </div>
  );
};

export default Filter;
